import React from 'react';
export const Header = () => {
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-367">
      <div className="max-w-[1200px] mx-auto flex justify-between items-center py-2 px-4" data-id="element-368">
        <div className="flex items-center" data-id="element-369">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ktds4aRCZkYDJdageQMuRp/ardava_logo.webp" alt="Ardava Logo" className="h-10" data-id="element-370" />
        </div>
        <div className="hidden md:flex space-x-6 text-sm" data-id="element-371">
          <a href="#features" className="text-gray-600 hover:text-gray-900" data-id="element-372">
            Features
          </a>
          <a href="#benefits" className="text-gray-600 hover:text-gray-900" data-id="element-373">
            Benefits
          </a>
          <a href="#reviews" className="text-gray-600 hover:text-gray-900" data-id="element-374">
            Reviews
          </a>
          <a href="#faq" className="text-gray-600 hover:text-gray-900" data-id="element-375">
            FAQ
          </a>
        </div>
        <div data-id="element-376">
          <a href="https://silentstruggle.shop/ardava-checkout" className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-1.5 rounded-md text-sm font-medium to-checkout" data-pass-params="1" data-id="element-377">
            FIND YOUR SIZE
          </a>
        </div>
      </div>
    </header>;
};